import { CarritoPage } from "src/app/pages/carrito/carrito.page";
import { secrets } from "./environment.secrets";

export const environment = {
  production: false,
  //ALPHA  https://clubalpha.com.mx/slider/
  getPosteoImageA: "media?parent=26094",
  getPosteoHorarioA2: "media?parent=26115",
  getPosteoHorarioA3: "media?parent=26118",
  direccionWPA: "https://clubalpha.com.mx/",
  npostHorariosA2: "horarioA2",
  npostHorariosA3: "horarioA3",
  getPosteoExternoA: "media?parent=26569",

  //CIMERA
  getImageC: "https://cimera.com.mx/wp-json/wp/v2/",
  getPosteoImageC: "media?parent=3923",
  getPosteoHorarioC: "media?parent=3955",
  getPostImagenC: "archivos/3923/",
  getPostHorarioC: "archivos/3955/",
  direccionWPC: "https://cimera.com.mx/",
  getPosteoExternoC: "media?parent=5026",

  //SPORTS
  getImage: "https://sportsplaza.mx/wp-json/wp/v2/",
  getPosteoImage: "media?parent=988808",
  getPosteoExternoS: "media?parent=989815",

  //CENIT
  getImageCe: "https://cenitgym.com/wp-json/wp/v2/",
  getPosteoImageCe: "media?parent=242",
  getPosteoHorarioCe: "media?parent=242",
  getPostHorarioCe: "archivos/242/",
  direccionWPCe: "https://cenitgym.com/",
  getPosteoExternoCe: "media?parent=336",

  //CIMERA GYM
  getImageCG: "https://cimeragym.com.mx/wp-json/wp/v2/",
  getPosteoImageCG: "media?parent=6",
  getPosteoHorarioCG: "media?parent=11",
  getPostImagenCG: "archivos/6/",
  getPostHorarioCG: "archivos/6/",
  direccionWPCG: "https://cimeragym.com.mx/",
  getPosteoExternoCimG: "media?parent=56",

  nPosteo: "slider",
  nPost: "horario",
  terminos: CarritoPage.terminos,

  //RAZÓN SOCIAL //alpha //sports //cimera //cenit // cimeragym // serdan
  club: 'cenit',
  web: true,
  productoDomiciliacion: 2731,

  // Version de esta App ACTUAL 
  appVersion: '9.1.7', //APPS DE ALPHA, CIMERA, SPORTS, CENIT
  // appVersion: '1.140', //APP CIMERA GYM

  //ENDPOINT GLOBAL Y API V2
  apiBaseUrl: "https://appalpha.ngrok.io/api/v2", // BASE URL API V2
  API_BASE_URL: "https://appalpha.ngrok.io/api/v2",
  global: "https://appalpha.ngrok.io/api/v2/", // Redirigido a API v2
  //  global: 'http://192.168.20.57:8070/', //URL SERVIDOR PRUEBAS http://192.168.20.102:8080/
  facturacion: "https://appalpha.ngrok.io/api/v2/", //URL SERVIDOR PRODUCCION
  // facturacion: "http://192.168.20.104:8000",
   // global: "https://appalpha.ngrok.io/", // URL SERVIDOR PRODUCCION
     //global: 'http://192.168.20.57:8070/', //URL SERVIDOR PRUEBAS http://192.168.20.102:8080/
    // global: 'https://hardcover-columnists-chen-navigator.trycloudflare.com/',
  //facturacion: "https://appalpha.ngrok.io/", //URL SERVIDOR PRODUCCION
  //facturacion: 'http://192.168.20.57:8090/',  //URL SERVIDOR PRUEBAS
  //facturacion: 'http://192.168.20.102:8080/',  //URL SERVIDOR PRUEBAS
  // facturacion: 'https://hardcover-columnists-chen-navigator.trycloudflare.com/',

  //Chatwoot
  tokenChatWootA3: secrets.chatwoot.tokenA3,
  tokenChatWootA2: secrets.chatwoot.tokenA2,
  tokenChatWootCIM: secrets.chatwoot.tokenCIM,
  tokenChatWootSP: secrets.chatwoot.tokenSP,
  tokenChatWootCEN: secrets.chatwoot.tokenCEN,
  tokenChatWootCIMG: secrets.chatwoot.tokenCIMG,

  // Api Url NOTIFICAICONES
  apiUrl: "https://appalpha.ngrok.io/api/v2/", // URL SERVIDOR PRODUCCION API V2
  // apiUrl: 'http://192.168.20.57:8080/api/', // URL SERVIDOR PRUEBAS
  // apiUrl: 'http://192.168.16.139:8080/api/', // URL SERVIDOR PRUEBAS LOCAL DESKTOP
  // apiUrl: 'https://hardcover-columnists-chen-navigator.trycloudflare.com/',

  // onesignalAppId: '350103d8-05c8-446c-81dc-81ec4ad5d9e6',
  onesignalAppId: "26f3a44d-7f9b-4542-ab3d-7fd01428f63c", // Android e IOS Alpha
  appidsports: '604420cb-062d-43a8-a6a3-2aeae087d3c9',
  appidcimera: '12f7c1ae-ad40-4336-be8f-202f61f8bed9',
  appidcenit: '823fea90-bb4d-43f8-b28c-a93fb746cf94',
  appidcimeragym: '',

  //reglamentos de pago:
  reglamentoAlpha: 'https://clubalpha.com.mx/reglamento_pagos_clubalpha_2025.pdf',
  reglamentoCim: 'https://cimera.com.mx/reglamento_pagos_cimera_2025.pdf',
  reglamentoSP:'https://sportsplaza.mx/reglamento_pagos_sportsplaza_2025.pdf',
  reglamentoCenit:'https://cenitgym.com/reglamento_pagos_cenit_2025.pdf',
  reglamentoCimG: 'https://cimeragym.com.mx/reglamento_pagos_serdan_2025.pdf',

  // Pruebas
   // global: 'http://192.168.20.57:8070/',
  // Compra de Pases de Estacionamiento
  apiPasesEstacionamientoComprar: 'api/odoo/pases-estacionamiento/comprar',
  // API Asesorias
  apiFast: 'https://invitaciones.ngrok.io/',
  // apiFastPruebas: 'http://192.168.16.248:8000/',
};
